
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1336Dialog extends Serenity.EntityDialog<Report_1336Row, any> {
        protected getFormKey() { return Report_1336Form.formKey; }
        protected getIdProperty() { return Report_1336Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1336Row.localTextPrefix; }
        protected getNameProperty() { return Report_1336Row.nameProperty; }
        protected getService() { return Report_1336Service.baseUrl; }
        protected getDeletePermission() { return Report_1336Row.deletePermission; }
        protected getInsertPermission() { return Report_1336Row.insertPermission; }
        protected getUpdatePermission() { return Report_1336Row.updatePermission; }

        protected form = new Report_1336Form(this.idPrefix);

    }
}